import Vue from "vue";
import vuetify from "@/plugins/vuetify";

import App from "@/App.vue";
import store from "@/store";
import router from "@/router";

import "@/plugins/axios";
import { moment } from "./config/vue/plugins/moment";

import { createProvider } from "@/vue-apollo";

import VueLodash from "vue-lodash";
import lodash from "lodash";

import { uppercaseDirective } from "@/config/vue/directives/uppercase.js";

import "@/global_events/index.js";

import { InactivityMonitor } from "@/inactivity_status/InactivityMonitor.js";
new InactivityMonitor().initialize();

import CKEditor from "@ckeditor/ckeditor5-vue";
Vue.use(CKEditor);

Vue.use(VueLodash, { name: "custom", lodash: lodash });

import ColorPlugin from "@/plugins/color-plugin";
Vue.use(ColorPlugin);

import randomKey from "@/plugins/random-key";
Vue.use(randomKey);

Vue.use(require("vue-moment"), {
  moment,
});

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import RichText from "@/components/utils/rich_text.vue";
Vue.component(RichText.name, RichText);

import apollo from "@/components/utils/apollo.vue";
Vue.component(apollo.name, apollo);

import navigation_drawer from "@/components/utils/navigation_drawer.vue";
Vue.component(navigation_drawer.name, navigation_drawer);

import FileUpload from "@/components/utils/file_upload.vue";
Vue.component(FileUpload.name, FileUpload);

import bigButton from "@/components/utils/big_button.vue";
Vue.component(bigButton.name, bigButton);

import authorization from "@/components/utils/authorization.vue";
Vue.component(authorization.name, authorization);

import authorizationTwo from "@/components/utils/authorization_two.vue";
Vue.component(authorizationTwo.name, authorizationTwo);

import EsignButton from "@/components/utils/esign.vue";
Vue.component(EsignButton.name, EsignButton);

Vue.config.productionTip = false;

var filter = function(content, length, clamp) {
  clamp = clamp || "...";
  return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter("truncate", filter);

Vue.mixin({
  directives: {
    uppercase: uppercaseDirective,
  },
  methods: {
    apolloMutate(arqs) {
      this.$store.dispatch("updateLoading", true);

      return this.$apollo
        .mutate(arqs)
        .then((resolve) => {
          return resolve;
        })
        .catch((error) => {
          this.$store.dispatch("createNotification", {
            message: "Ocorreu um erro.",
            type: "error",
          });

          console.log(error);

          throw error;
        })
        .finally(() => {
          //this.$store.dispatch("authentication/refreshToken");

          setTimeout(() => {
            this.$store.dispatch("updateLoading", false);
          }, 1000);
        });
    },
  },
});

new Vue({
  vuetify,
  store,
  apolloProvider: createProvider(),
  router,
  render: (h) => h(App),
}).$mount("#app");

// Turn animations back on some time after application has loaded
// Source: https://stackoverflow.com/questions/27938900/how-to-prevent-a-css-keyframe-animation-from-running-on-page-load
setTimeout(function() {
  document.body.className = "";
}, 1000);
